<template>
  <div>
    <el-select v-model="pin" class="w-full" :filterable="filterable">
      <el-option label="全部" value="" />
      <el-option
        v-for="item in partnerUserDTOList"
        :key="item.pin"
        :label="`客户ID:${item.customerId},PIN:${item.pin},用户登录名:${
          item.loginName
        }(${typeName(item.type)})`"
        :value="item.pin"
      />
    </el-select>
  </div>
</template>

<script>
import { getPartnerUserList } from '@/api/channel-api.js'
import { reactive, toRefs, watch } from '@vue/composition-api'
export default {
  // 组件名称
  name: 'UserSelect',
  props: {
    value: {
      type: String,
      default: '',
    },
    filterable: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  setup(props, { emit }) {
    const state = reactive({
      pin: props.value || '',
      partnerUserDTOList: [],
    })
    watch(
      () => state.pin,
      (val) => {
        emit('input', val)
      },
      {
        immediate: true,
      },
    )
    watch(
      () => props.value,
      (val) => {
        state.pin = val
      },
      {
        immediate: true,
      },
    )
    const getUserList = async () => {
      const { result } = await getPartnerUserList()
      state.partnerUserDTOList = result.partnerUserDTOList || []
    }
    getUserList()
    const typeName = (type) => {
      let typeName = ''
      //typeName就是注释
      if (type === 1) {
        typeName = '一级渠道商'
      }
      if (type === 2) {
        typeName = '二级渠道商'
      }
      if (type === 3) {
        typeName = '一级渠道商客户'
      }
      if (type === 4) {
        typeName = '二级渠道商客户'
      }
      return typeName
    }
    return {
      ...toRefs(state),
      typeName,
    }
  },
}
</script>
